import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ordersData from "layouts/orders/data/ordersData";
import AuthService from "services/AuthService";
import { useNavigate } from "react-router-dom";

function Orders() {
  const navigate = useNavigate();
  const currentUser = AuthService.getCurrentUser();

  if (currentUser === null) {
    navigate(`/login`);
  }

  const data = ordersData();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {data}
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
